import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=baf3d7fc&scoped=true&lang=pug&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=baf3d7fc&scoped=true&lang=css&"
import style1 from "./Error.vue?vue&type=style&index=1&id=baf3d7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf3d7fc",
  null
  
)

export default component.exports